export default "__VITE_ASSET__CqDaTRiW__"